// extracted by mini-css-extract-plugin
export default {"card":"zZ-z","carouselContainer":"AZ-z","carouselContent":"BZ-z"};